<template>
  <div class="row produto-spc-conciliador">
    <div v-for="(register, index) in list" :key="index" class="col-md-3 mb-4">
      <div class="p-4 bg-white rounded">
        <div class="d-flex justify-content-between">
          <div>
            <div class="label">Pacote</div>
            <div class="value">{{ register.nome }}</div>
          </div>
        </div>
        <div class="mt-3">
          <div class="label">Quantida de CNPJ</div>
          <div class="value">{{ register.qtdCnpj }}</div>
        </div>
        <div class="mt-3">
          <div class="label">Quantidade Adquirentes</div>
          <div class="value">{{ register.qtdAdquirentes }}</div>
        </div>
        <div class="mt-3">
          <div class="label">Quantidade Transações</div>
          <div class="value">{{ register.qtdTransacoes }}</div>
        </div>
        <div class="mt-3">
          <div class="label">Transações Excedentes</div>
          <div class="value">
            {{ register.transacoesExcedentes | currency }}
          </div>
        </div>
        <div class="mt-3">
          <div class="label">Adquirentes Extra</div>
          <div class="value">{{ register.adquirenteExra | currency }}</div>
        </div>
        <div class="mt-3">
          <div class="label">Custo Operadoras</div>
          <div class="value">{{ register.custoOperadoras }}</div>
        </div>
        <div class="mt-3">
          <div class="label">Filial Extra</div>
          <div class="value">
            {{ register.filialExtra ? register.filialExtra : "-" }}
          </div>
        </div>
        <div class="mt-3">
          <div class="label">Adesão</div>
          <div class="value">{{ register.adesao | currency }}</div>
        </div>
        <div class="mt-3">
          <div class="label">Mensalidade</div>
          <div class="value">{{ register.mensalidade | currency }}</div>
        </div>
        <div class="mt-3">
          <transition name="fade">
            <b-button
              class="btn-block"
              variant="success"
              data-toggle="modal"
              data-target="#modalOperadoras"
              @click="selecionarPlano(register.cod)"
              >SELECIONAR</b-button
            >
          </transition>
        </div>
        <div v-if="planoSel === register.cod" class="mt-3"></div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modalOperadoras"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalOperadoras"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-uppercase" id="modalOperadorasTitulo">
              Dados Adicionais
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              id="closeModalClick"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12 mb-3">
                <FormulateInput
                  type="number"
                  name="qtdCnpj"
                  v-model="qtdCnpj"
                  label="Quantidade de Cnpj"
                  validation="required"
                />
              </div>
            </div>
            <div class="formulate-input">
              <label class="formulate-input-label formulate-input-label--before"
                >Selecione sua(s) operadora(s)</label
              >
            </div>
            <multiselect
              class="pb-3"
              v-model="operadorasSel"
              :options="listaOperadoras"
              :multiple="true"
              :taggable="true"
              label="name"
              track-by="value"
              :selectLabel="'Selecione'"
              :selectedLabel="'Selecionado'"
              :deselectLabel="'Remover'"
              placeholder="Operadoras"
              :open-direction="'below'"
              @select="selecionarOperadora()"
            ></multiselect>
            <label v-if="erroOperadoras" class="danger mb-3">{{
              erroOperadoras
            }}</label>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-success fit-content"
                :disabled="loading"
                @click="salvar()"
              >
                <span
                  class="spinner-grow spinner-grow-sm pr-2"
                  role="status"
                  aria-hidden="true"
                  v-show="loading"
                ></span>
                <span v-if="loading">Salvando...</span>
                <span v-else>Salvar</span>
              </button>
              <button
                type="button"
                class="btn btn-danger fit-content"
                data-dismiss="modal"
                aria-label="Close"
                id="closeModalClick"
              >
                <span aria-hidden="true">Cancelar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect },
  name: "ListaPlanosConciliador",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      planoSel: null,
      operadorasSel: [],
      listaOperadoras: [],
      loading: false,
      qtdCnpj: 1,
      erroOperadoras: null,
    };
  },
  methods: {
    selecionarPlano(plano) {
      this.planoSel = plano;
      this.carregarOperadoras();
    },
    selecionarOperadora() {
      this.erroOperadoras = null;
    },
    carregarOperadoras() {
      this.$http
        .get("/api/Conciliador/ConsultarOperadorasSpcConciliador")
        .then((response) => {
          response.data.forEach((el) => {
            this.listaOperadoras.push({
              value: el.operadoraId,
              name: el.descricao,
            });
          });
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
            this.$router.push({ name: "painel-conciliador" });
          }
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }

          this.loading = false;
          this.error = error.response.data.mensagem;
        });
    },
    salvar() {
      if (this.operadorasSel.length) {
        const dados = {
          planoSel: this.planoSel,
          operadoras: this.operadorasSel,
          qtdCnpj: this.qtdCnpj,
        };
        document.querySelector("#closeModalClick").click();
        this.$emit("click", { dados });
      } else {
        this.erroOperadoras = "Obrigatório selecionar pelo menos 1 operadora";
      }
    },
    acao(action, id) {
      this.$emit(action, id);
    },
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";
.produto-spc-conciliador /deep/ {
  .material-icons {
    font-size: 38px;
  }
  .price-total {
    font-weight: 700;
    font-size: 22px;
  }
  @import "@/assets/scss/_vue-formulate.scss";

  .formulate-input {
    &[data-classification="select"] {
      select {
        padding: 10px;
        background: $dark-100;
        border: none;
        color: $dark;
        border-radius: 4px;
        line-height: 1.4;
      }
    }
    &[data-classification="text"] {
      input {
        border: 1px solid #cfcfcf;
        border-radius: 5px;
      }
    }
  }
}
.label {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 6px;
}
.value {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
.dropdown {
  position: relative;
  margin-right: -16px;
}
</style>
